import { createContext, useContext, useReducer } from 'react';
import { BaseLayoutState, BaseLayoutReducer, ACTION_TYPES } from './base-layout-reducer';


const BaseLayoutContext = createContext<BaseLayoutState | undefined>(undefined);
const BaseLayoutContextDispatchContext = createContext({} as any);

const BaseLayoutProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(BaseLayoutReducer, { dialogProps: { open: false }, messageProps: { open: false }, backdropPros: { open: false } } as BaseLayoutState);

    return (

        <BaseLayoutContext.Provider value={state}>
            <BaseLayoutContextDispatchContext.Provider value={dispatch}>
                {children}
            </BaseLayoutContextDispatchContext.Provider>
        </BaseLayoutContext.Provider>

    );
}

const useBaseLayoutState = () => {
    const context = useContext(BaseLayoutContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useBaseLayoutDispatch = () => {
    const context = useContext(BaseLayoutContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { BaseLayoutProvider, useBaseLayoutDispatch, useBaseLayoutState, ACTION_TYPES };
